/**
 Copyright Highway9 Networks Inc.
 */
import { DailyReport, DailyReportQuery } from "~/types/DailyReport";
import APIService from "./APIServices";

const dailyReportAPI = new APIService<DailyReport>("daily-reports");

async function getDailyReports(query: DailyReportQuery): Promise<DailyReport[]> {
  const data = (await dailyReportAPI.post("query", query)) as unknown as DailyReport[];
  return data ?? [];
}

/** Fire an on-demand Daily_VMC_Report DAG run; resolves once the trigger is accepted. */
async function generateDailyReport(): Promise<void> {
  // Called without a body so APIService.post returns the raw Response: fetch
  // resolves on HTTP 4xx/5xx, and a failed trigger must throw here — otherwise
  // the page starts its 5-minute poll for a report that will never arrive
  // (MCS-4151: UI/backend version skew turned this into a flickering loop).
  const resp = (await dailyReportAPI.post("generate")) as unknown as Response;
  if (!resp.ok) {
    throw new Error(`Daily report generation failed: HTTP ${resp.status}`);
  }
}

const dailyReportService = {
  getDailyReports,
  generateDailyReport,
};

export default dailyReportService;
